module.exports = __webpack_public_path__ + "static/media/initial-data-requirements.a6e5574f.png";